import { ApplyPromoCodeForm } from "@/features"
import styles from "./styles.module.scss"

export const ApplyPromoCodePage = () => {
  return (
    <div className={styles.page}>
      <ApplyPromoCodeForm />
    </div>
  )
}
